import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportingService } from '../reporting-service.service';
import { CurrentUser } from 'app/Models/CurrentUser';
import { ReportMenus } from 'app/Models/ReportMenusDto';
import { SharedServicesService } from 'app/shared/sharedservices/shared-services.service';
import { ReportMainData } from 'app/ReportingModel/ReportFiltering';

@Component({
    selector: 'app-reporting-admin-menu',
    templateUrl: './reporting-menu.component.html',
    styleUrls: ['./reporting-menu.component.scss']
})
export class ReportingMenuComponent implements OnInit {
    @Output() onLeftPanelClicked = new EventEmitter<boolean>();
    @Output() ReportMainData = new EventEmitter<ReportMainData>();
    // new EventEmitter<any>();
    showPanel = false;
    showReportsChilds = false;
    reportIconType = "chevron_right";
    menuClass = "chevron_right";
    getReportDetailsByRoleIdSubscription: Subscription;
    reportMenus: ReportMenus[];
    roleId: number = CurrentUser.RoleId;
    reportMainHeader: string = '';
    subscription: any;
    isConfigBoxHidden = false;
    reportId: number;
    constructor(private restService: ReportingService, public restSharedService: SharedServicesService) { }
    ngOnInit(): void {
        this.subscription = this.restSharedService.getConfigBoxReportComponentEmitter()
            .subscribe(item => this.getConfigBoxValue(item));
        this.getReportMenus();
        this.showPanel = true;
        this.onLeftPanelClicked.emit(this.showPanel);
    }
    getConfigBoxValue(item: boolean) {
        this.isConfigBoxHidden = item;
        const bodyWrapper = document.getElementById('mdc');
        if (!this.isConfigBoxHidden)
            bodyWrapper.style.marginTop = 65 + 'px';
        else
            bodyWrapper.style.marginTop = 0 + 'px';
    }
    leftPanel(showPanel) {
        this.showPanel = !showPanel;
        this.onLeftPanelClicked.emit(this.showPanel);
    }
    reportClicked(reportCode, reportId, reportName, reportHeaderCode) {
        this.restSharedService.activeLink = reportHeaderCode;
        let reportMainData = new ReportMainData();
        reportMainData.reportId = reportId;
        reportMainData.reportName = reportName;
        reportMainData.reportCode = reportCode;
        reportMainData.savedReportId = 0;
        reportMainData.savedReportName = '';
        reportMainData.savedReportFilterParameters = '';
        this.reportId = reportId;
        this.ReportMainData.emit(reportMainData);
        return false;
    }
    getReportMenus() {
        this.reportMenus = [];
        this.getReportDetailsByRoleIdSubscription =
            this.restService.GetReportMenus(this.roleId).subscribe(
                (data) => {
                    for (var i = 0; i < data.filter(x => x.ReportId != 0).length; i++) {
                        var item = data.filter(x => x.ReportId != 0)[i];
                        if (this.reportMenus.findIndex(x => x.ReportCode == item.ReportHeaderCode) == -1) {
                            let itemMenu: ReportMenus = {
                                ReportId: item.ReportHeaderId,
                                ReportName: item.ReportHeaderName,
                                ReportCode: item.ReportHeaderCode,
                                ReportSubMenus: []
                            };
                            this.reportMenus.push(itemMenu);
                        }
                        var reportMenuItem = this.reportMenus.find(x => x.ReportCode == item.ReportHeaderCode);
                        if (reportMenuItem.ReportSubMenus.findIndex(x => x.ReportCode == item.ReportCode) == -1) {
                            let itemSubMenu: ReportMenus = {
                                ReportId: item.ReportId,
                                ReportName: item.ReportName,
                                ReportCode: item.ReportCode,
                                ReportSubMenus: []
                            };
                            reportMenuItem.ReportSubMenus.push(itemSubMenu);
                        }
                    }
                    this.reportMainHeader = data.find(x => x.ReportId == 0).ReportHeaderName;
                },
                (err) => {
                },
                () => { }
            );
    }
}